<template>
  <v-card class="shadowCard text-center grafica-meta-ri">
    <v-card-title primary-title>
      <v-spacer></v-spacer>
      <div>{{ titulo }}</div>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-title v-if="subtitulo" primary-title>
      <v-spacer></v-spacer>
      <div>{{ subtitulo }}</div>
      <v-spacer></v-spacer>
    </v-card-title>

    <v-card-text>
      <div v-if="cargando && !planteles.length" class="py-8">
        <v-progress-circular indeterminate :color="color" :size="48" />
      </div>

      <div v-else-if="!planteles.length" class="grey--text py-8">
        No tienes sucursales asignadas en esta escuela.
      </div>

      <div v-else-if="esUna">
        <div class="plantel-nombre" v-if="unica.plantel">{{ unica.plantel }}</div>
        <v-progress-circular
          :rotate="90"
          :size="160"
          :width="15"
          :value="unica.pct || 0"
          :color="color"
        >
          <span class="text-h3"><b>{{ unica.lleva || 0 }}</b></span>
        </v-progress-circular>
        <div class="avance-frase mt-4">
          Ocupas <b>{{ unica.objetivo || 0 }}</b> alumnos,
          llevas <b>{{ unica.lleva || 0 }}</b>.
          <span class="avance-pct">{{ unica.pct || 0 }}% de avance</span>
        </div>
        <v-row class="align-center mt-3 text-h6">
          <v-col cols="6">
            <div>Objetivo</div>
            <div>{{ unica.objetivo || 0 }}</div>
          </v-col>
          <v-col cols="6">
            <div>Faltan</div>
            <div>{{ unica.faltan || 0 }}</div>
          </v-col>
          <v-col cols="12" class="grey--text text-subtitle-1">
            Reinscribibles: {{ unica.reinscribibles || 0 }}
          </v-col>
        </v-row>
      </div>

      <div v-else class="barras-sucursales text-left">
        <div
          v-for="item in planteles"
          :key="item.id_plantel"
          class="barra-sucursal"
        >
          <div class="d-flex justify-space-between align-center mb-1">
            <div class="barra-nombre">{{ item.plantel }}</div>
            <div class="barra-pct" :class="item.pct >= 100 ? 'barra-pct--ok' : ''">
              {{ item.pct || 0 }}%
            </div>
          </div>
          <div class="barra-frase">
            Ocupas {{ item.objetivo || 0 }} · Llevas {{ item.lleva || 0 }} · Faltan {{ item.faltan || 0 }}
          </div>
          <v-progress-linear
            :value="item.pct || 0"
            height="10"
            rounded
            :color="item.pct >= 100 ? 'green darken-1' : color"
            class="mt-1"
          />
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'GraficaMetaRi',

  props: {
    titulo: { type: String, default: '' },
    subtitulo: { type: String, default: 'RI semana 2' },
    planteles: { type: Array, default: () => [] },
    color: { type: String, default: 'blue' },
    cargando: { type: Boolean, default: false },
  },

  computed: {
    esUna() {
      return (this.planteles || []).length === 1
    },
    unica() {
      return (this.planteles && this.planteles[0]) || {}
    },
  },
}
</script>

<style scoped>
.grafica-meta-ri {
  height: 100%;
}

.plantel-nombre {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #546e7a;
  margin-bottom: 8px;
}

.avance-frase {
  font-size: 15px;
  color: #37474f;
  line-height: 1.4;
}

.avance-pct {
  display: block;
  margin-top: 4px;
  font-size: 1.15rem;
  font-weight: 800;
  color: #1a237e;
}

.barras-sucursales {
  padding: 4px 4px 8px;
}

.barra-sucursal {
  background: #f7f8fc;
  border: 1px solid #eef0f6;
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 10px;
}

.barra-sucursal:last-child {
  margin-bottom: 0;
}

.barra-nombre {
  font-size: 14px;
  font-weight: 800;
  color: #263238;
}

.barra-pct {
  font-size: 1.15rem;
  font-weight: 800;
  color: #1a237e;
}

.barra-pct--ok {
  color: #2e7d32;
}

.barra-frase {
  font-size: 12px;
  color: #78909c;
}
</style>
